<template>
    <div id="scan-login">
        <div class="qrcode-img">
            <img :src="qrcode" class="qrImage" alt="二维码" @load="imgLoaded">
            <div v-if="scanSuccess" class="wrapper">
                <i class="nucfont inuc-step-right"></i>
                <p>{{$t('app.scanSuccess')}}</p>
            </div>
            <div v-if="needFresh" class="fresh-code">
                <p>{{$t('app.qrInvalid')}}</p>
                <el-button type="primary" size="small" @click="freshQRImage">{{$t('app.freshQR')}}</el-button>
            </div>
        </div>
        <div class="qrcode-desc">
            <i class="nucfont inuc-scan"></i>
            <div class="right-txt">
                <p>{{$t('c.open')}} <span class="name">{{$t('app.appName')}}</span></p>
                <p>{{$t('app.scanLoginTip')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "@/api";
    import md5 from '@/utils/md5';
    import {Ticket} from "@/utils"
    const config = require('@/config');
    const qrURL = `${config.baseUrl}/qrapi/image/login`;

    export default {
        data() {
            return {
                rate: 1500,  // 请求频率ms
                uuid: '',
                qrcode: '',
                timer: 0,
                needFresh: false,
                scanSuccess: false
            }
        },
        created() {
            this.getQRImage();
            //this.startScanLoop();
        },
        computed: {},
        methods: {
            getQRImage() {
                this.uuid = md5.genRandomSelect(15);
                const culture = this.$i18n.locale;

                this.qrcode = `${qrURL}/${this.uuid}?culture=${culture}&ui-culture=${culture}`;
            },
            imgLoaded() {
                this.startScanLoop();
            },
            startScanLoop() {
                clearInterval(window.scanLoginTimer);

                window.scanLoginTimer = setInterval(() => {

                    if (this.timer >= 60000) {
                        this.needFresh = true;
                        this.endScanLoop();
                    }

                    this.timer += this.rate;

                    Ticket.remove()

                    api.qrcodeLogin(this.uuid, {version: config.version}).then(res => {
                        if (res.package) {
                            console.log(res.package);
                            this.scanSuccess = true;
                            this.endScanLoop();

                            setTimeout(() => {
                                this.$emit('scanLoginSuccess', res.package);
                            }, 300)
                        }
                    })
                }, this.rate);
            },
            freshQRImage() {
                this.timer = 0;
                this.needFresh = false;
                this.getQRImage();
                //this.startScanLoop();
            },
            endScanLoop() {
                clearInterval(window.scanLoginTimer);
            }
        },
        watch: {},
        destroyed() {
            this.endScanLoop()
        },
        components: {}
    }
</script>

<style lang="scss">
    @import "../../style/const";

    $mainColor: #4081dd;

    #scan-login {
        .qrcode-img {
            position: relative;
            text-align: center;

            .qrImage {
                width: 140px;
                height: 140px;
            }

            .wrapper {
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 140px;
                height: 140px;
                background-color: rgba(0,0,0,.6);

                .nucfont {
                    display: inline-block;
                    margin-top: 35px;
                    font-size: 38px;
                    color: #8DD332;
                }

                p {
                    margin-top: 10px;
                    color: #fff;
                }
            }

            .fresh-code {
                position: absolute;
                top: 0;
                left: 50%;
                width: 100%;
                height: 100%;
                transform: translateX(-50%);
                background-color: hsla(0,0%,100%,.95);
                > p {
                    margin-top: 45px;
                    margin-bottom: 8px;
                }
            }
        }

        .qrcode-desc {
            display: flex;
            width: 160px;
            margin: 2vh auto 0 auto;

            .nucfont {
                font-size: 32px;
                color: $mainColor;
            }

            .right-txt {
                margin-left: 10px;
                p {
                    line-height: 1.4;
                }
                .name {
                    color: $mainColor;
                }
            }
        }
    }

    .app-root:not(.lang-zh-CN) {
        .qrcode-desc {
            width: 185px!important;
        }
    }
</style>
